module.exports = __webpack_public_path__ + "media/images/dot-grid-0dae4b41.svg";